import companydetail from "./views/companydetail.vue";
import companydash from "./views/companydash.vue";
import companydashviewexternal from "./views/companydashviewexternal.vue";
import companydashviewoperator from "./views/companydashviewoperator.vue";
import companydashviewmaintainer from "./views/companydashviewmaintainer.vue";
import companydashviewengineer from "./views/companydashviewengineer.vue";
import companydashsafety from "./views/companydashsafety.vue";
import companydashtechnical from "./views/companydashtechnical.vue";
import companydashbusiness from "./views/companydashbusiness.vue";
import companydashengineering from "./views/companydashengineering.vue";
import companydashmaintenance from "./views/companydashmaintenance.vue";
import companymanagement from "./views/companymanagement.vue";

const routes = [
  {
    path: "/companydash",
    name: "companydash",
    component: companydash
  },
  {
    path: "/companydashviewexternal",
    name: "companydashviewexternal",
    component: companydashviewexternal
  },
  {
    path: "/companydashviewoperator",
    name: "companydashviewoperator",
    component: companydashviewoperator
  },
  {
    path: "/companydashviewmaintainer",
    name: "companydashviewmaintainer",
    component: companydashviewmaintainer
  },
  {
    path: "/companydashviewengineer",
    name: "companydashviewengineer",
    component: companydashviewengineer
  },
  {
    path: "/companydashsafety",
    name: "companydashsafety",
    component: companydashsafety
  },
  {
    path: "/companydashtechnical",
    name: "companydashtechnical",
    component: companydashtechnical
  },
  {
    path: "/companydashbusiness",
    name: "companydashbusiness",
    component: companydashbusiness
  },
  {
    path: "/companydashviewmaintainer",
    name: "companydashviewmaintainer",
    component: companydashviewmaintainer
  },
  {
    path: "/companydashengineering",
    name: "companydashengineering",
    component: companydashengineering
  },
  {
    path: "/companydashmaintenance",
    name: "companydashmaintenance",
    component: companydashmaintenance
  },
  {
    path: "/companydetail",
    name: "companydetail",
    component: companydetail
  },
  {
    path: "/companymanagement",
    name: "companymanagement",
    component: companymanagement
  }
];

export default routes;
